import React from 'react';
import {Row, Col} from 'react-bootstrap';

import Auxiliary from '../../hoc/Auxiliary/Auxiliary';
//import HorisontalBarGraph from '../HorisontalBarGraph/HorisontalBarGraph';
import ComparisonView from '../ComparisonView/ComparisonView';
import VerticalBarGraph from '../VerticalBarGraph/VerticalBarGraph';
import Table from '../Table/Table';

import './Dashboard.css';

import happy from '../../assets/Happy_Smiley.png';
import sad from '../../assets/Sad_Smiley.png';
import neutral from '../../assets/Neutral_Smiley.png';

const dashboard = (props) => {
    let totResponses = 0;
    let npsIndex = 0;
    let npsCnt = 0;
    let happyResponses = 0;
    let happyPercentage = 0;
    let neutralResponses = 0;
    let neutralPercentage = 0;
    let sadResponses = 0;
    let sadPercentage = 0;
    const compData = [[], [], [], [], []];
    //const dailyData = [[], [], [], [], []];
    const weekdayData = [
        ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'], 
        [0, 0, 0, 0, 0, 0, 0], 
        [0, 0, 0, 0, 0, 0, 0], 
        [0, 0, 0, 0, 0, 0, 0], 
        [0, 0, 0, 0, 0, 0, 0]
    ];
    const hourlyData = [
        ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', 
            '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]    
    ];
    let weekNumber = null;
    let bestRiser = {
        location: null,
        name: null,
        nps: NaN,
        diff: NaN    
    };
    let secondBestRiser = {
        location: null,
        name: null,
        nps: NaN,
        diff: NaN    
    };
    let worstFaller = {
        location: null,
        name: null,
        nps: NaN,
        diff: NaN    
    };
    let secondWorstFaller = {
        location: null,
        name: null,
        nps: NaN,
        diff: NaN    
    };

    for (let i = 0; i < props.device.clusters.length; i++){
        let cluster = props.device.clusters[i];
        let bestDevice = {
            name: null,
            nps: NaN,
            diff: NaN
        };
        let worstDevice = {
            name: null,
            nps: NaN,
            diff: NaN
        };

        compData[0].push(cluster.name);
        if (cluster.devices !== undefined){
            let cnt = 0;
            let npsTot = 0;
            let sadTot = 0;
            let neutralTot = 0;
            let happyTot = 0;
            for (let j = 0; j < cluster.devices.length; j++){
                let device = cluster.devices[j];
                if (device.stats !== undefined){
                    if (i === 0 && j === 0)
                        weekNumber = device.stats.thisWeekData.week;
                    if (!isNaN(device.stats.npsScore)){
                        cnt++;
                        npsTot += device.stats.npsScore;
                        sadTot += device.stats.eButtonPresses;
                        neutralTot += device.stats.cButtonPresses;
                        happyTot += device.stats.aButtonPresses;
                        // Riser
                        if (device.stats.diff > 0){
                            if (bestDevice.name === null){
                                bestDevice.name = device.name;
                                bestDevice.nps = device.stats.npsScore;
                                bestDevice.diff = device.stats.diff;
                            } 
                            else if (device.stats.diff > bestDevice.diff){
                                bestDevice.name = device.name;
                                bestDevice.nps = device.stats.npsScore;
                                bestDevice.diff = device.stats.diff;
                            }    
                        }
                        // Faller
                        if (device.stats.diff < 0){
                            if (worstDevice.name === null){
                                worstDevice.name = device.name;
                                worstDevice.nps = device.stats.npsScore;
                                worstDevice.diff = device.stats.diff;
                            } 
                            else if (device.stats.diff < worstDevice.diff){
                                worstDevice.name = device.name;
                                worstDevice.nps = device.stats.npsScore;
                                worstDevice.diff = device.stats.diff;
                            }
                        }
                        // Weekday
                        for(let k = 0; k < weekdayData[0].length; k++){
                            let resp = device.stats.thisWeekData.responses[k];
                            weekdayData[2][k] += resp.sadCnt;
                            weekdayData[3][k] += resp.neutralCnt;
                            weekdayData[4][k] += resp.happyCnt;
                            
                            // Hourly
                            for(let l = 0; l < hourlyData[0].length; l++){
                                let hResp = resp.hourCnt[l];
                                hourlyData[2][l] += hResp.sadCnt;
                                hourlyData[3][l] += hResp.neutralCnt;
                                hourlyData[4][l] += hResp.happyCnt;
                            }
                        }
                    }
                }
            }
            let totPushes = sadTot + neutralTot + happyTot;
            compData[1].push(cnt > 0 ? npsTot / cnt : 0);
            compData[2].push(totPushes > 0 ? sadTot / totPushes * 100 : 0);
            compData[3].push(totPushes > 0 ? neutralTot / totPushes * 100 : 0);
            compData[4].push(totPushes > 0 ? happyTot / totPushes * 100 : 0);

            sadResponses += sadTot;
            neutralResponses += neutralTot;
            happyResponses += happyTot;
            totResponses += totPushes;
            npsIndex += npsTot;
            npsCnt += cnt;
        }
        //console.log(bestDevice);
        //console.log(worstDevice);
        // Get risers and fallers
        if (bestDevice.name !== null){
            if (bestRiser.name === null){
                bestRiser.location = cluster.name;
                bestRiser.name = bestDevice.name;
                bestRiser.nps = bestDevice.nps;
                bestRiser.diff = bestDevice.diff;
            }
            else if (bestDevice.diff > bestRiser.diff){
                secondBestRiser.location = bestRiser.location;
                secondBestRiser.name = bestRiser.name;
                secondBestRiser.nps = bestRiser.nps;
                secondBestRiser.diff = bestRiser.diff;
                bestRiser.location = cluster.name;
                bestRiser.name = bestDevice.name;
                bestRiser.nps = bestDevice.nps;
                bestRiser.diff = bestDevice.diff;    
            }else if (secondBestRiser.name === null || 
                bestDevice.diff > secondBestRiser.diff){
                secondBestRiser.location = cluster.name;
                secondBestRiser.name = bestDevice.name;
                secondBestRiser.nps = bestDevice.nps;
                secondBestRiser.diff = bestDevice.diff;
            }    
        }
        // Fallers
        if (worstDevice.name !== null){
            if (worstFaller.name === null){
                worstFaller.location = cluster.name;
                worstFaller.name = worstDevice.name;
                worstFaller.nps = worstDevice.nps;
                worstFaller.diff = worstDevice.diff;
            }
            else if (worstDevice.diff < worstFaller.diff){
                secondWorstFaller.location = worstFaller.location;
                secondWorstFaller.name = worstFaller.name;
                secondWorstFaller.nps = worstFaller.nps;
                secondWorstFaller.diff = worstFaller.diff;
                worstFaller.location = cluster.name;
                worstFaller.name = worstDevice.name;
                worstFaller.nps = worstDevice.nps;
                worstFaller.diff = worstDevice.diff;    
            }else if (secondWorstFaller.name === null || 
                worstDevice.diff < secondWorstFaller.diff){
                secondWorstFaller.location = cluster.name;
                secondWorstFaller.name = worstDevice.name;
                secondWorstFaller.nps = worstDevice.nps;
                secondWorstFaller.diff = worstDevice.diff;
            }
        }
    }
    sadPercentage = sadResponses / totResponses * 100;
    neutralPercentage = neutralResponses / totResponses * 100;
    happyPercentage = happyResponses / totResponses * 100;
    npsIndex /= npsCnt;

    // Weekday
    for(let i = 0; i < weekdayData[0].length; i++){
        let total = weekdayData[2][i] + weekdayData[3][i] + weekdayData[4][i];
        weekdayData[1][i] = (weekdayData[4][i] / total * 100) - 
            (weekdayData[2][i] / total * 100);    
    }

    // Hourly
    for(let i = 0; i < hourlyData[0].length; i++){
        let total = hourlyData[2][i] + hourlyData[3][i] + hourlyData[4][i];
        hourlyData[1][i] = (hourlyData[4][i] / total * 100) - 
            (hourlyData[2][i] / total * 100);
    }
    
    return (
        <Auxiliary>
            <div className="DashboardHeader">
                <span className="DashboadTitleHeaderLeft">Weekly Report</span>
                <span className="DashboadTitleContentLeft">Week {weekNumber}</span>
                <span className="DashboadTitleHeaderRight">Management Report</span>
                <span className="DashboadTitleContentRight">Total</span>
            </div>
            <div className="DashboardBody">
                <Row>
                    <Col xs={1} className="Dashboard-col-xs-1">
                        <img src={happy} alt='Happy' className='DashboardFaceImage'/>
                    </Col>
                    <Col xs={2}>    
                        <div className="DashboardHappyNPS">{happyPercentage.toFixed(0)}%</div>
                        <div className="DashboardHappyResponse">{happyResponses} resp</div>
                    </Col>
                    <Col xs={1} className="Dashboard-col-xs-1">
                        <img src={neutral} alt='Neutral' className='DashboardFaceImage'/>
                        </Col>
                    <Col xs={2}>    
                        <div className="DashboardNeutralNPS">{neutralPercentage.toFixed(0)}%</div>
                        <div className="DashboardNeutralResponse">{neutralResponses} resp</div>
                    </Col>
                    <Col xs={1} className="Dashboard-col-xs-1">
                        <img src={sad} alt='Sad' className='DashboardFaceImage'/>
                        </Col>
                    <Col xs={2}>    
                        <div className="DashboardSadNPS">{sadPercentage.toFixed(0)}%</div>
                        <div className="DashboardSadResponse">{sadResponses} resp</div>
                    </Col>
                    <Col xs={3}>
                        <div className="DashboardTotalNPS">NPS: {npsIndex.toFixed(0)}</div>
                        <div className="DashboardTotalResponse">Responses: {totResponses}</div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        {/*<HorisontalBarGraph 
                            title="Comparison"
                            data={compData}
                            onEvent={props.onEvent}
                        />*/}
                        <ComparisonView
                            title="Comparions"
                            data={compData}
                            onClicked={props.onEvent}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col xs={6}>
                        <Table title="Risers" up first={bestRiser} second={secondBestRiser}/>
                    </Col>
                    <Col xs={6}>
                        <Table title="Fallers" first={worstFaller} second={secondWorstFaller}/>
                    </Col>
                </Row>
                {/*<Row>
                    <Col xs={12}>
                        <VerticalBarGraph 
                            title="All Units Combined - Daily distribution"
                            data={props.dailyData}
                        />
                    </Col>
                </Row>*/}
                <Row>
                    <Col xs={12}>
                        <VerticalBarGraph 
                            title="All Units Combined - Weekday distribution"
                            data={weekdayData}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <VerticalBarGraph 
                            title="All Units Combined - Hourly distribution"
                            data={hourlyData}
                        />
                    </Col>
                </Row>
            </div>
        </Auxiliary>
    );
};

export default dashboard;